import confirm from './lib/confirm';
import { destroyAll } from './lib/destroy';
import { ConfirmDialog } from './lib/ConfirmDialog';
import { useDialog } from './lib/useDialog';
const Dialog = ConfirmDialog;
Dialog.confirm = confirm;
Dialog.destroyAll = destroyAll;
Dialog.useDialog = useDialog;
export default Dialog;
export { dialogClasses } from './lib/style';
export { useDialog };
